import { Workflow } from "../interfaces";

export const byNameAndDescription = (search: string) => (workflow: Workflow) =>
    workflow.name.toLowerCase().includes(search.toLowerCase()) ||
    workflow.description.toLowerCase().includes(search.toLowerCase());